import React from "react";
import Box from "@mui/material/Box/Box";
import { Add } from "@mui/icons-material";
import { theme } from "../../special/genie-theme/genie-theme";
import { apiUrl } from "../../../utils/apiUrl";
import useUser from "../../../queries/routes/useUser";
import { useAuth0 } from "@auth0/auth0-react";

interface GenieThumbUploadProps {
  uploadFile: (data: any) => void;
}

function GenieThumbUpload({ uploadFile }: GenieThumbUploadProps) {
  const { getAccessTokenSilently } = useAuth0();
  const { data: user } = useUser();

  async function handleSubmit(event: React.FormEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement;
    if (target.files) {
      const myFile = target.files[0];
      const formData = new FormData();
      formData.append("file", myFile, myFile.name);
      const response = await fetch(
        apiUrl(
          `/api/media/${user?.purchasing_organizations[0].organization.id}/upload`
        ),
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${await getAccessTokenSilently()}`,
          },
          body: formData,
          redirect: "follow",
        }
      );
      const data = await response.json();
      uploadFile(data);
    }
  }

  function upload() {
    document.getElementById("selectImage")?.click();
  }

  return (
    <>
      <input
        id="selectImage"
        hidden
        type="file"
        onChange={handleSubmit}
        accept="image/png, image/gif, image/jpeg"
      />
      <Box
        onClick={upload}
        width={80}
        height={80}
        sx={{
          borderColor: "grey.300",
          borderWidth: 1,
          borderStyle: "dashed",
          borderRadius: theme.shape.borderRadius,
          display: "inline-block",
          margin: 1,
          transition: theme.transitions.create(["border"]),
          cursor: "pointer",
          position: "relative",
          "&:hover": {
            borderColor: "grey.500",
          },
        }}
      >
        <Add
          color={"primary"}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </Box>
    </>
  );
}

export default GenieThumbUpload;
